/** @jsxImportSource @emotion/react */

import css from '@emotion/css/macro'
import { observer } from 'mobx-react-lite'
import colors from '@sportninja/common/constants/appColors'
import Icon from '../../components/Icon'
import { useHistory, useLocation } from 'react-router-dom'
import { ROUTES } from '@sportninja/common/constants/app'
import { useMobxStore } from '../../state'
import { useEffect, useLayoutEffect, useMemo } from 'react'
import { useI18n } from '@shopify/react-i18n'

const currency = {
  1: 'CAD',
  2: 'USD',
}

export const HomePaymentBanner = observer(({ isInFrame }) => {
  if (isInFrame) {
    return null
  }

  const location = useLocation()
  const [i18n] = useI18n()
  const isHome = useMemo(() => location.pathname === '/home', [location])

  const {
    registration: {
      checkIfHasPaymentAvailable,
      cleanUpPaymentData,
      state: { hasDepositPaymentAvailable, hasInstallmentsPaymentAvailable },
    },
  } = useMobxStore()
  const history = useHistory()

  useLayoutEffect(() => {
    if (isHome) {
      checkIfHasPaymentAvailable()
    }
  }, [isHome])

  if (
    !isHome ||
    (hasDepositPaymentAvailable.length === 0 &&
      hasInstallmentsPaymentAvailable.length === 0)
  ) {
    return null
  }

  return (
    <div>
      {hasDepositPaymentAvailable.length > 0 &&
        hasDepositPaymentAvailable.map((item) => {
          if (item?.deposit_amount === 0) {
            return null
          }
          return (
            <div
              key={item?.id}
              css={css`
                background-color: ${colors.FLORAL_WHITE};
                border: 1px solid ${colors.AMERICAN_YELLOW};
                padding: 16px;
                gap: 8px;
                display: flex;
                flex-direction: column;
                border-radius: 8px;
                margin-bottom: 16px;
              `}
            >
              <div
                css={css`
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 16px;
                `}
              >
                <div
                  css={css`
                    display: flex;
                    align-items: center;
                  `}
                >
                  <Icon
                    name='exclamation-triangle'
                    color={colors.CAUTION_DARK}
                    fontSize={18}
                  />
                  <p
                    css={css`
                      margin-left: 8px;
                      font-size: 18px;
                      font-weight: 700;
                      color: ${colors.CAUTION_DARK};
                    `}
                  >
                    You Have a Pending Deposit
                  </p>
                </div>
                {/* <Icon
                    name='external-link'
                    color={colors.CAUTION_DARK}
                    fontSize={18}
                  /> */}
              </div>

              <a
                css={css`
                  display: flex;
                  align-items: center;
                `}
                onClick={() => history.push(`/team/${item?.team_id}`)}
              >
                {item?.team_image?.full_path && (
                  <div
                    css={css`
                      overflow: hidden;
                      border-radius: 8px;
                      width: 30px;
                      height: 30px;
                      margin-right: 8px;
                    `}
                  >
                    <img
                      src={item?.team_image?.full_path}
                      css={css`
                        width: 100%;
                        height: 100%;
                      `}
                    />
                  </div>
                )}
                <p
                  css={css`
                    color: ${colors.BLACK};
                    font-size: 16px;
                    font-weight: 700;
                  `}
                >
                  {item?.team_name}
                </p>
              </a>

              <a
                css={css`
                  display: flex;
                  align-items: center;
                  margin-top: 8px;
                `}
                onClick={() => history.push(`/schedule/${item?.schedule_id}`)}
              >
                <p
                  css={css`
                    color: ${colors.BLACK};
                    font-size: 16px;
                    font-weight: 700;
                  `}
                >
                  Competition:
                </p>
                <p
                  css={css`
                    color: ${colors.BLACK};
                    font-size: 16px;
                    margin-left: 8px;
                  `}
                >
                  {item?.root_schedule_name} - {item?.schedule_name}
                </p>
              </a>
              <div
                css={css`
                  display: flex;
                  align-items: center;
                  margin-top: 8px;
                `}
              >
                <p
                  css={css`
                    color: ${colors.BLACK};
                    font-size: 16px;
                    font-weight: 700;
                  `}
                >
                  Deposit:
                </p>
                <p
                  css={css`
                    color: ${colors.BLACK};
                    font-size: 16px;
                    margin-left: 8px;
                  `}
                >
                  {i18n.formatCurrency(item?.deposit_amount, {
                    currency: currency[item?.deposit_currency],
                    form: 'explicit',
                  })}
                </p>
              </div>
              <button
                css={css`
                  margin-top: 16px;
                  padding: 8px;
                  border-radius: 8px;
                  background-color: ${colors.AMERICAN_YELLOW};
                  font-size: 16px;
                  color: ${colors.BLACK};
                `}
                onClick={() => {
                  history.push(
                    `${ROUTES.REGISTRATION_PAYMENT}?divisionId=${item?.root_schedule_id}&teamId=${item?.team_id}`
                  )

                  setTimeout(() => {
                    cleanUpPaymentData()
                  }, 200)
                }}
              >
                PAY NOW
              </button>
            </div>
          )
        })}
      {hasInstallmentsPaymentAvailable.length > 0 &&
        hasInstallmentsPaymentAvailable.map((item) => (
          <div
            key={item?.id}
            css={css`
              background-color: ${colors.FLORAL_WHITE};
              border: 1px solid ${colors.AMERICAN_YELLOW};
              padding: 16px;
              gap: 8px;
              display: flex;
              flex-direction: column;
              border-radius: 8px;
              margin-bottom: 16px;
            `}
          >
            <div
              css={css`
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 16px;
              `}
            >
              <div
                css={css`
                  display: flex;
                  align-items: center;
                `}
              >
                <Icon
                  name='exclamation-triangle'
                  color={colors.CAUTION_DARK}
                  fontSize={18}
                />
                <p
                  css={css`
                    margin-left: 8px;
                    font-size: 18px;
                    font-weight: 700;
                    color: ${colors.CAUTION_DARK};
                  `}
                >
                  You Have a Pending Installment
                </p>
              </div>
              {/* <Icon
                name='external-link'
                color={colors.CAUTION_DARK}
                fontSize={18}
              /> */}
            </div>

            <div
              css={css`
                display: flex;
                align-items: center;
              `}
            >
              <div
                css={css`
                  overflow: hidden;
                  border-radius: 8px;
                  width: 30px;
                  height: 30px;
                `}
              >
                <img
                  src='https://via.placeholder.com/150'
                  css={css`
                    width: 100%;
                    height: 100%;
                  `}
                />
              </div>
              <p
                css={css`
                  color: ${colors.BLACK};
                  font-size: 16px;
                  font-weight: 700;
                  margin-left: 8px;
                `}
              >
                The SportNinjas
              </p>
            </div>

            <div
              css={css`
                display: flex;
                align-items: center;
                margin-top: 8px;
              `}
            >
              <p
                css={css`
                  color: ${colors.BLACK};
                  font-size: 16px;
                  font-weight: 700;
                `}
              >
                Competition:
              </p>
              <p
                css={css`
                  color: ${colors.BLACK};
                  font-size: 16px;
                  margin-left: 8px;
                `}
              >
                Sprint State - Qualifiers
              </p>
            </div>
            <div
              css={css`
                display: flex;
                align-items: center;
                margin-top: 8px;
              `}
            >
              <p
                css={css`
                  color: ${colors.BLACK};
                  font-size: 16px;
                  font-weight: 700;
                `}
              >
                Installment :
              </p>
              <p
                css={css`
                  color: ${colors.BLACK};
                  font-size: 16px;
                  margin-left: 8px;
                `}
              >
                $ 1,000.00
              </p>
            </div>
            <button
              css={css`
                margin-top: 16px;
                padding: 8px;
                border-radius: 8px;
                background-color: ${colors.AMERICAN_YELLOW};
                font-size: 16px;
                color: ${colors.BLACK};
              `}
              onClick={() =>
                history.push(ROUTES.REGISTRATION_PAYMENT, { from: 'HOME' })
              }
            >
              PAY NOW
            </button>
          </div>
        ))}
    </div>
  )
})
